import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    allEnquiresLoading: false,
    allEnquiresSuccess: {},
    allEnquiresError: '',
    allCalBackRequestLoading: false,
    allCalBackRequestSuccess: {},
    allCalBackRequestError: '',

    allMasterEnquiresLoading: false,
    allMasterEnquiresSuccess: {},
    allMasterEnquiresError: '',

    allParentEnquiresLoading: false,
    allParentEnquiresSuccess: {},
    allParentEnquiresError: '',

    createEnquiryLoading: false,
    createEnquirySuccess: {},
    createEnquiryError: '',

    updateQueryLoading: false,
    updateQuerySuccess: {},
    updateQueryError: '',

    getEnquiryDetailsLoading: false,
    getEnquiryDetailsSuccess: null,
    getEnquiryDetailsError: '',

    allEnquiresAccessLoading: false,
    allEnquiresAccessSuccess: {},
    allEnquiresAccessError: '',

}

export const enquiresSlice = createSlice({
    name: 'enquires',
    initialState,
    reducers: {

        setAllEnquiresLoading: (state, action) => {
            state.allEnquiresLoading = true;
            state.allEnquiresSuccess = null;
            state.allEnquiresError = '';
        },
        setAllEnquiresSuccess: (state, action) => {
            state.allEnquiresLoading = false;
            state.allEnquiresSuccess = action.payload;
            state.allEnquiresError = '';
        },
        setAllEnquiresError: (state, action) => {
            state.allEnquiresLoading = false;
            state.allEnquiresSuccess = null;
            state.allEnquiresError = action.payload;
        },
        setAllCallBackRequestLoading: (state, action) => {
            state.allCalBackRequestLoading = true;
            state.allCalBackRequestSuccess = null;
            state.allCalBackRequestError = '';
        },
        setAllCallBackRequestSuccess: (state, action) => {
            state.allCalBackRequestLoading = false;
            state.allCalBackRequestSuccess = action.payload;
            state.allCalBackRequestError = '';
        },
        setAllCallBackRequestError: (state, action) => {
            state.allCalBackRequestLoading = false;
            state.allCalBackRequestSuccess = null;
            state.allCalBackRequestError = action.payload;
        },
        setAllParentEnquiresLoading: (state, action) => {
            state.allParentEnquiresLoading = true;
            state.allParentEnquiresSuccess = null;
            state.allParentEnquiresError = '';
        },
        setAllParentEnquiresSuccess: (state, action) => {
            state.allParentEnquiresLoading = false;
            state.allParentEnquiresSuccess = action.payload;
            state.allParentEnquiresError = '';
        },
        setAllParentEnquiresError: (state, action) => {
            state.allParentEnquiresLoading = false;
            state.allParentEnquiresSuccess = null;
            state.allParentEnquiresError = action.payload;
        },
        setAllMasterEnquiresLoading: (state, action) => {
            state.allMasterEnquiresLoading = true;
            state.allMasterEnquiresSuccess = null;
            state.allMasterEnquiresError = '';
        },
        setAllMasterEnquiresSuccess: (state, action) => {
            state.allMasterEnquiresLoading = false;
            state.allMasterEnquiresSuccess = action.payload;
            state.allMasterEnquiresError = '';
        },
        setAllMasterEnquiresError: (state, action) => {
            state.allMasterEnquiresLoading = false;
            state.allMasterEnquiresSuccess = null;
            state.allMasterEnquiresError = action.payload;
        },
        setCreateEnquiryLoading: (state) => {
            state.createEnquiryLoading = true;
            state.createEnquirySuccess = {};
            state.createEnquiryError = '';
        },
        setCreateEnquirySuccess: (state, action) => {
            state.createEnquiryLoading = false;
            state.createEnquirySuccess = action.payload;
            state.createEnquiryError = '';
        },
        setCreateEnquiryError: (state, action) => {
            state.createEnquiryLoading = false;
            state.createEnquirySuccess = {};
            state.createEnquiryError = action.payload;
        },
        setUpdateQueryLoading: (state) => {
            state.updateQueryLoading = true;
            state.updateQuerySuccess = {};
            state.updateQueryError = '';
        },
        setUpdateQuerySuccess: (state, action) => {
            state.updateQueryLoading = false;
            state.updateQuerySuccess = action.payload;
            state.updateQueryError = '';
        },
        setUpdateQueryError: (state, action) => {
            state.updateQueryLoading = false;
            state.updateQuerySuccess = {};
            state.updateQueryError = action.payload;
        },
        setEnquiryDetailsLoading: (state) => {
            state.getEnquiryDetailsLoading = true;
            state.getEnquiryDetailsSuccess = {};
            state.getEnquiryDetailsError = '';
        },
        setEnquiryDetailsSuccess: (state, action) => {
            state.getEnquiryDetailsLoading = false;
            state.getEnquiryDetailsSuccess = action.payload;
            state.getEnquiryDetailsError = '';
        },
        setEnquiryDetailsError: (state, action) => {
            state.getEnquiryDetailsLoading = false;
            state.getEnquiryDetailsSuccess = {};
            state.getEnquiryDetailsError = action.payload;
        },
        resetEnquiryDetails: (state) => {
            state.createEnquirySuccess = {};
            state.getEnquiryDetailsSuccess = {};
        },
        resetParentEnquiryDetails: (state) => {
            state.updateQuerySuccess = {};
        },
        setAllparentAccessListLoading: (state, action) => {
            state.allEnquiresAccessLoading = true;
            state.allEnquiresAccessSuccess = null;
            state.allEnquiresAccessError = '';
        },
        setAllparentAccessListSuccess: (state, action) => {
            state.allEnquiresAccessLoading = false;
            state.allEnquiresAccessSuccess = action.payload;
            state.allEnquiresAccessError = '';
        },
        seAllparentAccessListError: (state, action) => {
            state.allEnquiresAccessLoading = false;
            state.allEnquiresAccessSuccess = null;
            state.allEnquiresAccessError = action.payload;
        },
    }
})

export const {
    setAllEnquiresLoading, setAllEnquiresSuccess, setAllEnquiresError,
    setAllCallBackRequestLoading, setAllCallBackRequestSuccess, setAllCallBackRequestError,
    setAllParentEnquiresLoading, setAllParentEnquiresSuccess, setAllParentEnquiresError,
    setAllMasterEnquiresLoading, setAllMasterEnquiresSuccess, setAllMasterEnquiresError,
    setCreateEnquiryLoading, setCreateEnquirySuccess, setCreateEnquiryError,
    setUpdateQueryLoading, setUpdateQuerySuccess, setUpdateQueryError,
    setEnquiryDetailsLoading, setEnquiryDetailsSuccess, setEnquiryDetailsError,
    setAllparentAccessListLoading, setAllparentAccessListSuccess, seAllparentAccessListError,
    resetEnquiryDetails, resetParentEnquiryDetails
} = enquiresSlice.actions;


export default enquiresSlice.reducer;